import React from 'react';

import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  button: {
    background: theme.palette.background.default,
    border: 'none',
    color: theme.palette.text.tertiary,
    display: 'inline-flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    fontSize: theme.typography.body2.fontSize,
    transition: 'background .2s',
    borderRadius: '4px',
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    padding: `${theme.spacing(0.75)}px ${theme.spacing(0.75)}px`,
    '&:hover': {
      cursor: 'pointer',
      background: theme.palette.background.surface.pressed,
      top: 8,
      bottom: 8,
    },
    '& svg': {
      maxHeight: 50,
      maxWidth: 50,
      marginRight: theme.spacing(0.7),
      marginTop: -2,
    },
    '&:disabled': {
      cursor: 'inherit',
      background: theme.palette.background.default,
    },
  },
  noBackground: {
    background: 'transparent',
    '&:disabled': {
      cursor: 'inherit',
      background: 'transparent',
    },
  },
  noLabelButton: {
    height: theme.spacing(4),
    '& svg': {
      marginRight: 0,
    },
  },
}));

export const TertiaryButton = ({ label, icon, className, onClick, disabled, type, noBackground, style }) => {
  const classes = useStyles();

  return (
    <button
      disabled={disabled}
      style={style}
      className={`${classes.button} ${!label ? classes.noLabelButton : ''} ${
        noBackground ? classes.noBackground : ''
      } ${className || ''}`}
      type={type || 'button'}
      onClick={onClick}
    >
      {icon}
      {label && <span>{label}</span>}
    </button>
  );
};
